import React, { useEffect, useState } from "react";
import { InfoCardSection } from "../components/InfoCardSection";
import { useCommonStyles } from "../useCommonStyles";
import { dialogTokenLocale } from "./dialog-token-locale";
import { useDispatch } from "react-redux";
import { showErrorMessages } from "../../../../state/app/appActions";
import { axiosGet } from "../../../../main/app-axios";
import { HelpContent } from "../components/HelpContent";
import { Box } from "@material-ui/core";

const DialogTokenContent = ({ mode = 'retirada', orderId, isAbbiamoStatusNotDone }) => {
    const { subtitle, topContent } = useCommonStyles();

    const [isLoading, setIsLoading] = useState(true);
    const [token, setToken] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        setIsLoading(true);
        axiosGet(`/api/pedidos/delivery-tokens/${orderId}`).then((response) => {

            if (!response || response.status !== 200) {
                dispatch(showErrorMessages([{ message: response?.data?.message }]));

                return;
            }

            const tokenResponse = mode === 'retirada' ? response.data.tokenRetirada : response.data.tokenInsucesso;

            setToken(tokenResponse);

        }).finally(() => {
            setIsLoading(false);
        });
    }, [mode, orderId]);

    return (
        <Box className={topContent}>
            <InfoCardSection title={dialogTokenLocale[mode].codeText} token={token} isLoading={isLoading} />
            <span className={subtitle} dangerouslySetInnerHTML={{ __html: dialogTokenLocale[mode].subtitle }} />
            {mode === 'retirada' && <InfoCardSection title="Validação do código de retirada" isLoading={isAbbiamoStatusNotDone} />}
            <InfoCardSection title={dialogTokenLocale[mode].orderText} isLoading={isAbbiamoStatusNotDone} />
            <HelpContent helpText={dialogTokenLocale[mode].helpText} />
        </Box>
    );
};

export default DialogTokenContent;